// extracted by mini-css-extract-plugin
module.exports = {"text-and-select-text-attribution":"text-and-select_text-and-select-text-attribution__2vm-3"};